export default __webpack_public_path__ + "static/media/jaegerScreen.4934420a.png";